export default __webpack_public_path__ + "locales/el-GR/Ldap.json?hash=5addb8031855c9fd5fa6dbb4a6866d48";